import React from "react";
import { useAppContext } from "../contexts/AppContext";

const ContactList = () => {
  const { contacts, deleteContact } = useAppContext();

  return (
    <div>
      <h2>Contact List</h2>
      <ul>
        {contacts.map((contact) => (
          <li key={contact.id}>
            {contact.name}
            <button onClick={() => deleteContact(contact.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactList;
